import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'common/components/checkbox';
import {isSelected} from '../../helpers';
import './index.scss';

export default class Category extends React.Component {
  static propTypes = {
    categoryOption: PropTypes.array,
    childOptions: PropTypes.array,
    onDeselectCategory: PropTypes.func,
    onDeselectChild: PropTypes.func,
    onSelectCategory: PropTypes.func,
    onSelectChild: PropTypes.func,
    selections: PropTypes.array,
  };

  render() {
    const {
      categoryOption,
      childOptions,
      onDeselectCategory,
      onDeselectChild,
      onSelectCategory,
      onSelectChild,
      selections,
    } = this.props;
    const [category, categoryLabel] = categoryOption;
    return (
      <div className={'FormOrderedSelectMultiple-Category'}>
        <div className={'Category-parentOption'}>
          <Checkbox
            checked={isSelected(selections, category)}
            dumb={true}
            label={categoryLabel}
            name={category}
            onDeselect={() => onDeselectCategory(category)}
            onSelect={() => onSelectCategory(category)}
          />
        </div>
        <div
          className={'Category-childOptions'}
          style={{
            display: isSelected(selections, category) ? 'inherit' : 'none',
          }}>
          {childOptions.map(([child, label]) => {
            const name = `${category}-${child}`;
            return (
              <Checkbox
                checked={isSelected(selections, category, child)}
                dumb={true}
                key={name}
                label={label}
                name={name}
                onDeselect={() => onDeselectChild(category, child)}
                onSelect={() => onSelectChild(category, child)}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
